module.exports = {
      id: "search-gray-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#search-gray-color",
      toString: function () {
        return this.url;
      }
    }